import { SVGInterface } from "../../interface";

const ContentCheck = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M19 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V21C3 22.1 3.9 23 5 23H19C20.1 23 21 22.1 21 21V5C21 3.9 20.1 3 19 3ZM12 3C12.55 3 13 3.45 13 4C13 4.55 12.55 5 12 5C11.45 5 11 4.55 11 4C11 3.45 11.45 3 12 3ZM19 21H5V5H7V8H17V5H19V21Z"
      fill={color || "#0E171F"}
    />
    <path
      d="M7.29297 14.707L11 18.414L16.707 12.707L15.293 11.293L11 15.586L8.70697 13.293L7.29297 14.707Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default ContentCheck;
